import z from 'zod';
import { FanforgeUserJwtClaimsBaseSchema } from './fanforge-user-jwt-claims-base';

export const FanforgeUserJwtClaimsWebSchema = FanforgeUserJwtClaimsBaseSchema.extend({
  amr: z.literal('web'), // authentication methods reference
  username: z.string(),
});

export type FanforgeUserJwtClaimsWeb = z.infer<typeof FanforgeUserJwtClaimsWebSchema>;
